var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24906 3.75V12.1275L4.58906 8.4675C4.29656 8.175 3.81656 8.175 3.52406 8.4675C3.23156 8.76 3.23156 9.2325 3.52406 9.525L8.46656 14.4675C8.75906 14.76 9.23156 14.76 9.52406 14.4675L14.4666 9.525C14.7591 9.2325 14.7591 8.76 14.4666 8.4675C14.1741 8.175 13.7016 8.175 13.4091 8.4675L9.74906 12.1275V3.75C9.74906 3.3375 9.41156 3 8.99906 3C8.58656 3 8.24906 3.3375 8.24906 3.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownward);
export default __webpack_public_path__ + "static/media/arrow-downward.fd3908154ac2ce7f197aba5faabef44d.svg";
export { ForwardRef as ReactComponent };